export default {
    data: () => ({
        translations: {
            newUser: {
                el: "Προσθήκη Νέου Χρήστη",
                en: "Add New User",
                it: "Aggiungi Nuovo Utente"
            },
            updateUser: {
                el: "Ενημέρωση Δικαιωμάτων Χρήστη",
                en: "Update User Permissions",
                it: "Aggiorna Permessi Utente"
            },
            mobile: {
                el: "Κινητό",
                en: "Mobile",
                it: "Mobile"
            },
            password: {
                el: "Κωδικός Σύνδεσης",
                en: "Password",
                it: "Parola d'Ordine"
            },
            permissions: {
                el: "",
                en: "Permissions",
                it: ""
            },
            updateAll: {
                el: "Ενημέρωση Όλων",
                en: "Update All",
                it: "Aggiorna Tutto"
            },
            role: {
                el: "Ρόλος",
                en: "Role",
                it: "Ruolo"
            },
        }
    })
};
